// extracted by mini-css-extract-plugin
module.exports = {"outer":"_150BC","heading":"_33-uc","cardOuter":"_14uND"};